"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button(scene, x, y, textureAtlas, frameNameOff, frameNameOn, pixelPerfect) {
        if (frameNameOn === void 0) { frameNameOn = frameNameOff; }
        var _this = _super.call(this, scene, x, y, textureAtlas, frameNameOff) || this;
        if (pixelPerfect) {
            _this.setInteractive(_this.scene.input.makePixelPerfect(20));
            _this.setInteractive({ pixelPerfect: true });
        }
        else {
            _this.setInteractive();
        }
        if (frameNameOff !== frameNameOn) {
            _this.on("pointerover", function () {
                _this.setFrame(frameNameOn);
            }, _this);
            _this.on("pointerout", function () {
                _this.setFrame(frameNameOff);
            }, _this);
            _this.on("pointerdown", function () {
                _this.setFrame(frameNameOn);
            }, _this);
            _this.on("pointerup", function () {
                _this.setFrame(frameNameOff);
            }, _this);
        }
        return _this;
    }
    Button.prototype.setFrames = function (frameNameOff, frameNameOn) {
        var _this = this;
        if (frameNameOn === void 0) { frameNameOn = frameNameOff; }
        this.on("pointerover", function () {
            _this.setFrame(frameNameOn);
        }, this);
        this.on("pointerout", function () {
            _this.setFrame(frameNameOff);
        }, this);
        this.on("pointerdown", function () {
            _this.setFrame(frameNameOn);
        }, this);
        this.on("pointerup", function () {
            _this.setFrame(frameNameOff);
        }, this);
    };
    Button.prototype.setInflationTween = function (ratio, defaultScaleX, defaultScaleY, tween, tweenData) {
        var _this = this;
        if (defaultScaleX === void 0) { defaultScaleX = this.scaleX; }
        if (defaultScaleY === void 0) { defaultScaleY = this.scaleY; }
        this.setScale(defaultScaleX, defaultScaleY);
        this.defaultScale = { x: defaultScaleX, y: defaultScaleY };
        if (tween) {
            if (!tweenData) {
                tweenData = { ease: Phaser.Math.Easing.Cubic.Out, duration: 200 };
            }
        }
        this.on("pointerover", function () {
            if (tween) {
                _this.scene.tweens.add({
                    targets: [_this],
                    scaleX: _this.defaultScale.x * ratio,
                    scaleY: _this.defaultScale.y * ratio,
                    ease: tweenData.ease,
                    duration: tweenData.duration,
                });
            }
            else {
                _this.setScale(_this.defaultScale.x * ratio, _this.defaultScale.y * ratio);
            }
        }, this);
        this.on("pointerout", function () {
            if (tween) {
                _this.scene.tweens.add({
                    targets: [_this],
                    scaleX: _this.defaultScale.x,
                    scaleY: _this.defaultScale.y,
                    ease: tweenData.ease,
                    duration: tweenData.duration,
                });
            }
            else {
                _this.setScale(_this.defaultScale.x, _this.defaultScale.y);
            }
        }, this);
        this.on("pointerdown", function () {
            if (_this.scene.game.device.os.desktop) {
                _this.setScale(_this.defaultScale.x, _this.defaultScale.y);
            }
            else {
                _this.setScale(_this.defaultScale.x * ratio, _this.defaultScale.y * ratio);
            }
        }, this);
        this.on("pointerup", function () {
            if (_this.scene.game.device.os.desktop) {
                _this.setScale(_this.defaultScale.x * ratio, _this.defaultScale.y * ratio);
            }
            else {
                _this.setScale(_this.defaultScale.x, _this.defaultScale.y);
            }
        }, this);
    };
    Button.prototype.onUp = function (f, context) {
        this.on("pointerup", f, context);
    };
    Button.prototype.onDown = function (f, context) {
        this.on("pointerdown", f, context);
    };
    Button.prototype.onOver = function (f, context) {
        this.on("pointerover", f, context);
    };
    Button.prototype.onOut = function (f, context) {
        this.on("pointerout", f, context);
    };
    return Button;
}(Phaser.GameObjects.Image));
exports.Button = Button;
